/* globals addQueryParam, getNextDays, updateEventBind, dateMidpoint, getTimeRange */
/* The MIT License
 *
 * Copyright (c) 2013, Sebastian Sdorra
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

'use strict';

var tableWidgetsGlobals = {
	urlPfx: '2/factndx/{0}',
	frontendPfx: '/application/f/home.html#/'
};
// list of every widget, used for iterating over tablularWidgetProperties object
var masterTableWidgetList = ['procurementActions', 'procurementActionsForCurUser', 'procurementActionsForCurUser2', 'myInventoryActions'];

// name must match the chart type in the API call
// eventName: event watched by directive, of the form 'event:<widgetname>Ctrl:getChart'
// fmtService: Formatting service used for the values of the chart
// addnlLabelText: Label used for the bottom number if there is one, or top if there isn't
// bgNumClass: class used for the color of the bgNum
// bgNumParentDivClass: class used to style the right section for 1 or 2 values
// bgNumValIdx: 'end'
// addnlBgNumUnits: additional units added to the end of the bgNum
// drilldownDefaultTabs: tab to show in item drilldown
// drillDownUrl: url to follow when "view report" is clicked
// expandedTitle: title to show for details table
// chartUrl: url for chart data
// tableUrl: url for table data
// title: override title of widget

var tablularWidgetProperties = {
	'procurementActions': {
		name: 'Open Procurement Tasks',
		description: 'Lists all open procurement tasks.',
		thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/table.png',
		categories: ['All', 'Task Management'],
		config: {},
		slideshowView: false,
		isActive: true,
		eventName: 'event:procurementActionsCtrl:getTable',
		addnlLabelText: null,
		isEditable: false,
		bgNumClass: null,
		bgNumParentDivClass: null,
		bgNumValIdx: null,
		addnlBgNumUnits: null,
		sortParms: {
			'allTasks': {
				actionDueDate: 'desc'
			},
			'myTasks': {
				actionDueDate: 'asc'
			}
		},
		ignoreFilters: {
			'myTasks': ['buyerCode' , 'buyers', 'taskStatus', 'responsibleNdx'],
			'allTasks': ['taskStatus']
		},
		spclFlag1: {
			'myTasks': 'forCurUser',
			'allTasks': 'none'
		},
		tableUrl: {
			'myTasks': tableWidgetsGlobals['urlPfx'] + '/ProcurementTasksReport?taskStatus=Open,Review Later&sort=actionDueDate&currentUser=true',
			'allTasks': tableWidgetsGlobals['urlPfx'] + '/ProcurementTasksReport?currentUser=false'
		},
		drillDownUrl: {
			'myTasks': tableWidgetsGlobals['frontendPfx'] + 'supply-chain/procurement-tasks/?drilldown=1&taskStatus=Open,Review Later&forCurUser=true&sort=actionDueDate&sortDesc=0',
			'allTasks': tableWidgetsGlobals['frontendPfx'] + 'supply-chain/procurement-tasks/?drilldown=1&sort=actionLastUpdateDate&sortDesc=1&taskStatus=Open,Review Later'
		},

		reactDrilldownUrl: frontendPfx + 'supply-chain/procurement-tasks/',
		reactDrilldownSorters: [{ property: 'actionLastUpdateDate', direction: 'DESC' }],
		reactDrilldownFilters: [{ id: 'taskStatus', values: ['Open', 'Review Later'] }],

		templateUrl: '/application/f/dashboard/widgets/widgetProcurementActions.html',
		controller: 'genericBuyerTblCtrl',
		defaultTab: 'none',
		getPromises: function($http, hostUrl, tableUrl, type, filterService) {
			var promises = [];
			var baseUrl = hostUrl + String.format(tableUrl.split('?')[0], filterService.getFactoryList());
			var body = {};
			body.filters = filterService.getFiltersForPost();
			if (this['ignoreFilters'][type]) {
				var ignoreFilters = this['ignoreFilters'][type];
				body.filters = _.filter(body.filters, function(filter) {
					return _.indexOf(ignoreFilters, filter.key) === -1;
				});
			}
			if (type === 'myTasks') {
				body.filters.push({'key': 'responsibleNdx', 'value': [globalConfig.user.id], 'operator': 'in'});
			}

			body.filters.push({'key': 'taskStatus', 'value': ['Open', 'Review Later'], 'operator': 'in'});

			body.columns = ['actionStatus', 'itemCode', 'itemCodeDisplay', 'factoryName', 'actionSubject', 'actionDescription', 'actionCategory', 'actionOwner', 'actionDueDate', 
				'actionCreator', 'actionCreatedDate', 'actionCompletedDate', 'actionOwnerNdx', 'taskId', 'actionIsActive', 'actionCategoryNdx', 'isActiveCategory', 'actionStatusNdx'];
			body.paging = {
				start: 0,
				limit: 5
			};
			body.sorters = [];
			if (this['sortParms'] && this['sortParms'][type]) {
				angular.forEach(this['sortParms'][type], function(sortDir, sortCol) {
					body.sorters.push({property: sortCol, direction: sortDir});
				});
			}
			promises.push($http.post(baseUrl, _.merge({operation:'rows'}, body)));
			promises.push($http.post(baseUrl, _.merge({operation:'count'}, body)));
			return promises;
		},
		dataFunction: function (scope, responses, tabs, currencyFormatService) {
			var drillDownUrl = this.drillDownUrl;
			var ignoreFilters = this.ignoreFilters;
			var sortParams = this.sortParms;
			scope.procurementTasks = {};

			var startIndex = 0;
			angular.forEach(tabs, function (tab, index) {
				scope.procurementTasks[tab] = processProcurementTaskResponse(responses[startIndex + index], responses[startIndex + index + 1]);
				startIndex++;
			});

			function processProcurementTaskResponse(response, responseCount) {
				var data = {
					data: null,
					totalRows: 0,
					empty: true
				};

				if (responseCount && responseCount !== '') {
					data.totalRows = responseCount.total;
					data.empty = responseCount.total === 0;
				}
				if (response && response !== '') {
					data.data = response;
				}

				scope.formatCurrency = function(amount) {
					return currencyFormatService.getWithParameters(amount, 0, response.targetCurrencySymbol);
				};
				return data;
			}

			scope.selectTab = function(selectedTab) {
				scope.data = scope.procurementTasks[selectedTab].data;
				scope.loading = false;
				scope.empty = scope.procurementTasks[selectedTab].empty;
				if (!scope.empty) {
					scope.generateTableParams(sortParams[selectedTab], scope.data);
					scope.mapIcons();
				}
				scope.setActiveTab(selectedTab);
				scope.activeTab = selectedTab;

				if (selectedTab !== scope.settings.activeTab) {
					scope.settings.activeTab = selectedTab;
					scope.saveWidgetSettings(true);
				}

				var widgetId = '#procurementTaskWidget' + scope.$id;
				if (scope.settings.activeTab === 'myTasks') {
					jQuery(widgetId + ' .my-tasks-tab').addClass('active');
					jQuery(widgetId + ' .all-tasks-tab').removeClass('active');
				} else {
					jQuery(widgetId + ' .all-tasks-tab').addClass('active');
					jQuery(widgetId + ' .my-tasks-tab').removeClass('active');
				}
				scope.$parent.content.defaultDrillDownUrl = drillDownUrl[selectedTab];
				scope.$parent.content.ignoreFilters = ignoreFilters[selectedTab];
				scope.setDrilldownUrl();
			};
			if (scope.settings.activeTab === 'none') {
				scope.settings.activeTab = !scope.procurementTasks['myTasks'].empty ? 'myTasks': 'allTasks';
			}
			scope.selectTab(scope.settings.activeTab);
		}
	},
	'procurementActionsForCurUser': {
		name: 'My Procurement Tasks',
		description: 'Lists all open procurement tasks for the current users.',
		thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/table.png',
		categories: [],
		config: {},
		slideshowView: false,
		isActive: true,
		eventName: 'event:procurementActionsForCurUserCtrl:getTable',
		addnlLabelText: null,
		isEditable: false,
		bgNumClass: null,
		bgNumParentDivClass: null,
		bgNumValIdx: null,
		addnlBgNumUnits: null,
		sortParms: {
			actionLastUpdateDate: 'desc'
		},
		spclFlag1: 'forCurUser',
		tableUrl: urlPfx + '/ProcurementActions',
		templateUrl: '/application/f/dashboard/widgets/widgetProcurementActions.html',
		drillDownUrl: tableWidgetsGlobals['frontendPfx '] + 'supply-chain/procurement-tasks/?drilldown=1&forCurUser=true&sort=actionLastUpdateDate&sortDesc=1',
		controller: 'genericBuyerTblCtrl'
	},
	'procurementActionsForCurUser2': {
		name: 'My Procurement Tasks',
		description: 'Summary of tasks assigned to the current user.',
		thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/table.png',
		categories: ['All', 'Task Management'],
		config: {},
		slideshowView: true,
		isActive: false,
		eventName: 'event:procurementActionsForCurUser2Ctrl:getTable',
		addnlLabelText: null,
		isEditable: false,
		bgNumClass: null,
		bgNumParentDivClass: null,
		bgNumValIdx: null,
		addnlBgNumUnits: null,
		sortParms: {
			actionDueDate: 'asc'
		},
		spclFlag1: 'forCurUser',
		ignoreFilters: ['buyerCode', 'buyers', 'taskStatus'],
		tableUrl: urlPfx + '/ProcurementActions?taskStatus=Open&sort=actionDueDate',
		templateUrl: '/application/f/dashboard/widgets/widgetProcurementActions2.html',
		drillDownUrl: tableWidgetsGlobals['frontendPfx'] + 'supply-chain/procurement-tasks/?drilldown=1&taskStatus=Open&forCurUser=true&sort=actionDueDate&sortDesc=0',
		controller: 'genericBuyerTblCtrl'
	},
	'myInventoryActions': {
		name: 'Open Inventory Actions',
		description: 'Summary of open inventory actions.',
		thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/table.png',
		categories: ['All', 'Inventory', 'Task Management'],
		config: {},
		slideshowView: true,
		isActive: true,
		eventName: 'event:myInventoryActionsCtrl:getTable',
		addnlLabelText: null,
		isEditable: false,
		bgNumKey: 'potentialSavings',
		addnlBgNumUnits: 'Potential Savings',
		sortParms: {
			potentialSavings: 'desc'
		},
		ignoreFilters: {
			'myActions': ['buyerCode', 'buyers', 'taskStatus', 'responsibleNdx', 'taskCategory'],
			'allActions': ['taskStatus', 'responsibleNdx', 'taskCategory']
		},
		tableUrl: {
			'myActions': tableWidgetsGlobals['urlPfx'] + '/Top5InventoryActions?currentUser=true',
			'allActions': tableWidgetsGlobals['urlPfx'] + '/Top5InventoryActions?currentUser=false'
		},
		templateUrl: '/application/f/dashboard/widgets/widgetMyInventoryActions.html',
		drillDownUrl: {
			'myActions': tableWidgetsGlobals['frontendPfx'] + 'supply-chain/inventory-actions/?drilldown=1&forCurUser=true&inventoryActionStatus=isOpen,isSnoozed&sort=potentialSavings&sortDesc=1',
			'allActions': tableWidgetsGlobals['frontendPfx'] + 'supply-chain/inventory-actions/?drilldown=1&inventoryActionStatus=isOpen,isSnoozed&sort=potentialSavings&sortDesc=1'
		},
		controller: 'genericBuyerTblCtrl',
		defaultTab: 'myActions',
		dataFunction: function (scope, responses, tabs, currencyFormatService) {
			var drillDownUrl = this.drillDownUrl;
			var ignoreFilters = this.ignoreFilters;
			scope.inventoryActions = {};
			angular.forEach(responses, function (response, index) {
				scope.inventoryActions[tabs[index]] = processInventoryResponse(response);
			});

			function processInventoryResponse(response) {
				var data = {
					data: null,
					totalRows: 0,
					empty: true
				};
				if (response && response !== '') {
					data.data = response;
					data.totalRows = response.count;
					data.empty = response.count === 0;
				}

				scope.formatCurrency = function(amount) {
					return currencyFormatService.getWithParameters(amount, 0, response.targetCurrencySymbol);
				};
				return data;
			}

			scope.selectTab = function(selectedTab) {
				scope.data = scope.inventoryActions[selectedTab].data;
				scope.loading = false;
				scope.empty = scope.inventoryActions[selectedTab].empty;
				scope.totalRows = scope.empty ? 0 : scope.data.count;
				if (!scope.empty) {
					scope.generateTableParams(this.sortParms, scope.data);
					scope.mapIcons();
				}
				scope.activeTab = selectedTab;

				if (selectedTab !== scope.settings.activeTab) {
					scope.settings.activeTab = selectedTab;
					scope.saveWidgetSettings(true);
				}


				if (scope.settings.activeTab === 'myActions') {
					jQuery('.my-actions-tab').addClass('active');
					jQuery('.all-actions-tab').removeClass('active');
				} else {
					jQuery('.all-actions-tab').addClass('active');
					jQuery('.my-actions-tab').removeClass('active');
				}
				scope.$parent.content.defaultDrillDownUrl = drillDownUrl[selectedTab];
				scope.$parent.content.ignoreFilters = ignoreFilters[selectedTab];
				scope.setDrilldownUrl();
			};
			scope.selectTab(scope.settings.activeTab);
		}
	}
};

// create and register all the widgets
(function() {
	'use strict';

	angular.module('widgets.buyer')
	.config(buyerTableWidgetsConfig);

	buyerTableWidgetsConfig.$inject = ['dashboardProvider', 'WEEKLY_LOG_ITEM_FIELDS'];
	function buyerTableWidgetsConfig(dashboardProvider, WEEKLY_LOG_ITEM_FIELDS) {
		// register widget
		for (var i = 0; i < masterTableWidgetList.length; i++) {
			var widgetName = masterTableWidgetList[i];
			var widgetConfig = getWidgetsDefaults(widgetName, tablularWidgetProperties[widgetName], 'genericBuyerTblCtrl', WEEKLY_LOG_ITEM_FIELDS);
			dashboardProvider
				.widget(widgetName, angular.extend({
					controller: 'genericBuyerTblCtrl'
				}, widgetConfig));
		}
	}
})();